export default {"src":"/_next/static/media/big-text-theme-icon.6ecc7b47.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};